import { AbstractControl, UntypedFormArray, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ExtendedTruckSize } from '../../../../../../common/constants/truck-size';

export const uliSelectValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  return control.value?.uliDetails?.length > 0 ? null : { noUliSelected: true };
};

export const updateUliFromValidator: ValidatorFn = (form: UntypedFormGroup): ValidationErrors | null => {
  const isTruckInfoComplete =
    form.controls.truckInformation.value?.truckSize === ExtendedTruckSize.XX
      ? true
      : form.controls.truckInformation.value?.complete;
  return (form.controls.uliDetails as UntypedFormArray).controls.some(
    (group: UntypedFormGroup) => group.dirty && group.status !== 'DISABLED',
  ) || !isTruckInfoComplete
    ? { shouldUpdateUli: true }
    : null;
};

export const fieldRequiredValidator: ValidatorFn = (form: UntypedFormGroup): ValidationErrors | null => {
  return form.controls.uliDetails?.invalid || form.controls.truckInformation?.invalid ? { required: true } : null;
};
